<template>
    <div>
        <v-row justify="space-between" align="center">
            <v-col
                    cols="auto">
                <h2 class="mb-2">{{$t('notifications.title')}}</h2>
            </v-col>
            <v-col
                    v-if="unreadNotificationsCount"
                    cols="auto">
                <v-menu bottom left>
                    <template v-slot:activator="{ on }">
                        <v-btn
                                icon
                                v-on="on"
                        >
                            <v-icon>mdi-dots-vertical</v-icon>
                        </v-btn>
                    </template>

                    <v-list>
                        <v-list-item @click="markAllNotificationsAsRead()">
                            <v-list-item-text>
                                {{ $t('notifications.mark_all_as_read')}}
                            </v-list-item-text>
                        </v-list-item>
                    </v-list>
                </v-menu>
            </v-col>
        </v-row>
        <v-alert
                prominent
                v-for="notification of notifications"
                :key="notification.id"
        >
            <v-row align="center"
                   @click="action(notification)"
            >
                <v-col cols="auto"
                       class="image">
                    <template v-if="notification.metadata.product">
                        <img :src="notification.metadata.product.images[0]" alt="" height="75"/>
                    </template>
                </v-col>
                <v-col class="grow">
                    <template v-if="notification.metadata.product">
                        <strong>{{ notification.metadata.product.title }}...
                            <template v-if="notification.metadata.product.reference"> - {{ $t('notifications.ref') }} {{
                                notification.metadata.product.reference }}
                            </template>
                        </strong>
                    </template><br/>
                    <small>{{notification.received_datetime | momentDate}}</small>
                    <br/>
                    <p class="ma-0" v-html="notification.text"></p>
                </v-col>
            </v-row>
        </v-alert>

        <p v-if="!notifications.length && !loading">
            {{ $t('notifications.no_notification')}}
        </p>

        <p v-if="!notifications.length && loading">
            {{ $t('notifications.loading')}}
        </p>

        <v-pagination
                v-if="countPage>1"
                v-model="options.page"
                class="my-4 "
                :length="countPage"
                total-visible="10"
        ></v-pagination>
    </div>

</template>

<script>
    import {mapState} from "vuex";

    export default {
        name: 'Notifications.vue',
        data() {
            return {
                loading: false,
                totalItems: 0,
                notifications: {},
                options: {
                    page: 1,
                    itemsPerPage: 10,
                },
            }
        },
        methods: {
            loadNotifications() {
                this.loading = true;
                this.notifications = [];
                this.$axios.get('notifications?page=' + this.options.page)
                    .then(response => {
                        this.loading = false;
                        this.notifications = response.data['hydra:member'];
                        this.totalItems = response.data['hydra:totalItems'];
                    });
            },
            markAsRead(notification) {
                this.$axios.post('notifications/' + notification.id + '/reads', {})
                    .then(() => {
                        notification.read_datetime = true;
                        this.$store.commit('decreaseUnreadNotificationsCount');
                    });
            },
            markAllNotificationsAsRead() {
                if (this.unreadNotificationsCount === 0) return;
                this.$axios.post('notifications/reads', {})
                    .then(() => {
                        this.$store.commit('setUnreadNotificationsCount', 0);
                    });
            },
            action(notification) {
                this.markAsRead(notification);
                const type = notification.type;
                const orderType = notification.metadata?.order?.shipping_class;

                if (type === 'catalog.product.accepted') {
                    this.$router.push({path: `/products?status%5B%5D=PENDING_REVIEW&status%5B%5D=ACCEPTED`});
                } else if (type === 'catalog.product.permanent_rejection' || type === 'catalog.product.temporary_rejection') {
                    this.$router.push({path: `/products?status=REJECTED`});
                } else if (type === 'catalog.product.published') {
                    this.$router.push({path: `/products?status%5B%5D=AVAILABLE_FOR_SALE&status%5B%5D=HIDDEN_FOR_SALE`});
                } else if (type === 'shipping.shipment.direct' || ((type === 'shipping.shipment.indirect_in_stock' || type === 'account.order.parcel_not_sent.first_reminder' || type === 'account.order.parcel_not_sent.second_reminder') && orderType === 'DIRECT')) {
                    this.$router.push({path: `/shipments?kind=FROM_STORE_TO_CUSTOMER&status%5B%5D=PENDING_DEPOSIT&status%5B%5D=AWAITING_LABEL_GENERATION`});
                } else if (type === 'shipping.shipment.indirect' || ((type === 'shipping.shipment.indirect_in_stock' || type === 'account.order.parcel_not_sent.first_reminder' || type === 'account.order.parcel_not_sent.second_reminder') && orderType === 'PREMIUM')) {
                    this.$router.push({path: `/shipments?kind=FROM_STORE_TO_IMPARFAITE&status%5B%5D=PENDING_DEPOSIT&status%5B%5D=AWAITING_LABEL_GENERATION`});
                } else if (type === 'accounting.order.cancelled') {
                    this.$router.push({path: `/products?status%5B%5D=AVAILABLE_FOR_SALE&status%5B%5D=HIDDEN_FOR_SALE`});
                } else if (type === 'shipping.shipment.received_by_carrier' || type === 'shipping.shipment.delivered_to_customer') {
                    this.$router.push({path: `/orders/?status%5B%5D=PENDING_DELIVERY&status%5B%5D=PENDING_CUSTOMER_ACCEPTANCE&status%5B%5D=AVAILABLE_FOR_TRANSFER`});
                } else if (type === 'accounting.order.payout.unlocked') {
                    this.$router.push({path: `/orders/?status%5B%5D=TRANSFERRED`});
                }
            }
        },
        mounted() {
            this.loadNotifications();
        },
        computed: {
            ...mapState(['userInformation', 'unreadNotificationsCount']),
            countPage: function () {
                return Math.ceil(this.totalItems / 10);
            },
        },
        watch: {
            options: {
                handler() {
                    this.loadNotifications();
                },
                deep: true
            }
        },
    }
</script>
<style scoped lang="scss">
    .v-alert {
        cursor: pointer;
    }

    .image {
        text-align: center;
        width: 75px;
        img {
            max-width: 100%;
        }
    }
</style>
